module.exports = __webpack_public_path__ + "img/share.924e127.png";